import { useTranslation } from 'react-i18next';

import * as St from './CustomerExpectationModal.styles';

import { useRetailerDocument } from '~/core/hooks/useRetailerDocuments';
import { RetailerDocumentType } from '~/core/models';
import CommonButton from '~atoms/CommonButton';
import DocumentViewer from '~atoms/DocumentViewer';

type CustomerExpectationModalProps = {
  isVisible: boolean;
  setIsVisible: (isVisible: boolean) => void;
  setAgreementSelected: (agreementSelected: boolean) => void;
  setCustomerExpectationModelSelected: (
    customerExpectationModelSelected: boolean
  ) => void;
};

const CustomerExpectationModal = ({
  isVisible,
  setIsVisible,
  setAgreementSelected,
  setCustomerExpectationModelSelected,
}: CustomerExpectationModalProps) => {
  const { t } = useTranslation();

  const customerExpectationURL = useRetailerDocument(
    RetailerDocumentType.CUSTOMER_EXPECTATIONS
  );

  const handleOpenPDF = () => {
    if (customerExpectationURL) {
      window.open(customerExpectationURL, '_blank');
    }
  };

  const handleModalAgreeButton = () => {
    setAgreementSelected(true);
    setCustomerExpectationModelSelected(false);
  };

  return (
    <St.Container
      title={t('ORDER_SUMMARY.ESTIMATE_SECTION.CUSTOMER_EXPECTATION.TITLE')}
      isVisible={isVisible}
      onClose={setIsVisible}
      content={<DocumentViewer url={customerExpectationURL ?? ''} />}
      footer={[
        <CommonButton
          key="back"
          onClick={() => setIsVisible(false)}
          data-style="remove-secondary"
        >
          {t(
            'ORDER_SUMMARY.ESTIMATE_SECTION.CUSTOMER_EXPECTATION.CANCEL_BUTTON'
          )}
        </CommonButton>,
        <CommonButton key="submit" onClick={handleOpenPDF}>
          {t(
            'ORDER_SUMMARY.ESTIMATE_SECTION.CUSTOMER_EXPECTATION.DOWNLOAD_BUTTON'
          )}
        </CommonButton>,
        <CommonButton key={undefined} onClick={handleModalAgreeButton}>
          {t('ORDER_SUMMARY.ESTIMATE_SECTION.CUSTOMER_EXPECTATION.BUTTON')}
        </CommonButton>,
      ]}
    />
  );
};

export default CustomerExpectationModal;
